Barba.Dispatcher.on('transitionCompleted', function() {
    
    // Init ScrollMagic Controller
    let controller = new ScrollMagic.Controller();
    let $scroller = $(".scroller");

    // Set the scroller at -50vh

    //Edit crauch... Hab das ein angepasst damit ich den scroller direkt danach schließen kann
    //Wär ein bischen kompliziert geworden wenn kein Hero Image vorhanden ist...
    TweenMax.set($scroller, { css:{ transform: 'translateY(' + (-window.innerHeight / 2) + 'px)', marginBottom: -window.innerHeight / 2} });
    var tween_scroller = TweenMax.to($scroller, window.innerHeight / 2, {  css:{transform:'translateY(0)', marginBottom:0} });

    var scene1 = new ScrollMagic.Scene({
        duration: window.innerHeight,
        reverse: true // allows the effect to trigger when scrolled in reverse direction
    })
    .setTween(tween_scroller)
    // .addIndicators()
    .addTo(controller);


    //  init scrollmagic
    var controller2 = new ScrollMagic.Controller();
    
    //  loop parallax sections
    $(".parallax-section").each( function () {
        
        var bg = $(this).find(".parallax-section__bg");
        
        // Add tweenmax for backgroundParallax
        var parallax = TweenMax.from( bg, 1, {
            y: '-50%',
            ease: Power0.easeNone
        } );
        
        // Create scrollmagic scene
        var parallaxScene = new ScrollMagic.Scene({
            triggerElement: this, // <-- Use this to select current element
            triggerHook: 1,
            duration: '200%',
        })
        .setTween(parallax)
        // .addIndicators()
        .addTo(controller2);
        
    });


    if (window.location.hash != "") {
        $('html, body').animate({
            scrollTop: $(window.location.hash).offset().top + window.innerHeight / 2
        }, 800);
    }
});